var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageLoad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 980,
    height: 736,
    role: "img",
    viewBox: "0 0 980 736",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Image-loading") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M871.1 0.5H108.9C49 0.5 0 49.5 0 109.4V626.7C0 686.6 49 735.6 108.9 735.6H871.1C931 735.6 980 686.6 980 626.7V109.4C980 49.5 931 0.5 871.1 0.5ZM939.2 615.3C939.2 670.2 914.7 694.7 859.8 694.7H120.3C65.4 694.7 40.9 670.2 40.9 615.3V120.7C40.9 65.8 65.4 41.3 120.3 41.3H859.8C914.7 41.3 939.2 65.8 939.2 120.7V615.3V615.3ZM306.3 286.3L408.3 368L673.7 143.4L877.9 327.2V633.5H102.1V449.7L306.3 286.3ZM183.8 102.6C138.7 102.6 102.1 139.2 102.1 184.3C102.1 229.4 138.7 266 183.8 266C228.9 266 265.5 229.4 265.5 184.3C265.5 139.2 228.9 102.6 183.8 102.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLoad);
export default __webpack_public_path__ + "static/media/image-load.a694a112f3fa7081f81ca15c332bfc8c.svg";
export { ForwardRef as ReactComponent };